export default {
    fields: [
        {
            key: "id",
            label:"#",
            sorter: false,
            filter: false,
            _filter: false,
            active: true,
            _style: "width:10%",
        },
        {
            key: "lead_id",
            label:"lead_id",
            sorter: false,
            filter: true,
            _filter: true,
            active: true,
            _style: "width:10%",
        },
        {
            key: "status",
            label:"status",
            sorter: false,
            filter: true,
            _filter: true,
            active: true,
            _style: "width:10%",
        },
        {
            key: "request_report",
            label:"request_report",
            sorter: false,
            filter: true,
            _filter: true,
            active: true,
            _style: "width:35%",
        },
        {
            key: "response",
            label:"response",
            sorter: false,
            filter: true,
            _filter: true,
            active: true,
            _style: "width:35%",
        },
        
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: false,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
}